<h4 matDialogTitle>Off Hire Items</h4>
<div matDialogContent class="flex flex-col space-y-6" [formGroup]="offHireDetails">
  <ng-container formGroupName="items">
    @for (item of itemsFormArray.controls; track item.value.id; let i = $index) {
    <off-hire-item class="flex flex-col space-y-6 justify-start align-stretch" fxLayout="column" fxLayoutGap="18px"
      fxLayoutAlign="start stretch" [hireItem]="item.value.hireItem" [charge]="item.value.charge"
      [currencyRate]="currencyRate" [currency]="currency" [suggestedPriceResponse]="item.value.price_suggestion"
      [pricingType]="item.value.pricing_type" (openPriceDialog)="openPriceStructureDialog(item)"
      (priceLaterToggled)="togglePriceLater($event, item.value.id)"
      [quantityFormControl]="item.controls.quantity_returned"></off-hire-item>
    }
  </ng-container>
  <div class="flex flex-col justify-start align-start">
    <p>Specify the date and location these items have been returned.</p>
    <div class="flex md:flex-row flex-col justify-start md:justify-stretch items-stretch md:items-start gap-2 w-full">
      <mat-form-field class="basis-full">
        <mat-label>Off hire date</mat-label>
        <input matInput formControlName="off_hire_date" name="Date" [matDatepicker]="picker"
          placeholder="Off hire date" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      </mat-form-field>
      <mat-datepicker #picker></mat-datepicker>

      <mat-form-field class="basis-full">
        <mat-label>Off hire time</mat-label>
        <input matInput name="off_hire_time" formControlName="off_hire_time"
          (blur)="updateTimeEnteredManually('off_hire_time', pickerOff)" placeholder="Off hire time" />
        <mat-error *ngIf="offHireDetails.get('off_hire_time').hasError('invalidTime')">Invalid time value, please enter
          in the format: HH:mm (24
          hour)</mat-error>
        <mat-icon matSuffix (click)="pickerOff.open()">access_time</mat-icon>
      </mat-form-field>
      <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
        (timeSet)="updateTime($event, 'off_hire_time')" #pickerOff></ngx-mat-timepicker>


      <mat-form-field class="basis-full">
        <mat-select placeholder="Location in" name="Location in" id="location" formControlName="location_in"
          required="true">
          <mat-option *ngFor="let location of locations$ | async" [value]="location.id">{{ location.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <p fxFlex.gt-sm="1 1 80" *ngIf="isClosingAction" id="closing-action" class="text-yellow-700er">
    <strong>Note:</strong> After you save these items, no more items will be
    left on hire and the hire contract will be closed.
  </p>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button type="reset" (click)="dialogRef.close()">
    Cancel
  </button>
  <button mat-raised-button type="submit" color="primary" (click)="saveOffHire()" data-cy="save-off-hire"
    [disabled]="!offHireDetails.valid">
    Save
  </button>
</mat-dialog-actions>